module.exports = [
  '1-kilo-blue.svg',
  '1-kilo-pink.svg',
  '2-kilo-blue.svg',
  '2-kilo-pink.svg',
  'arrow-down-blue.svg',
  'arrow-down-pink.svg',
  'baby-blue.svg',
  'baby-pink.svg',
  'back-blue.svg',
  'back-pink.svg',
  'balloon-blue.svg',
  'balloon-pink.svg',
  'bandaid-blue.svg',
  'bandaid-pink.svg',
  'bear-blue.svg',
  'bear-pink.svg',
  'big-bottle-blue.svg',
  'big-bottle-pink.svg',
  'book-blue.svg',
  'book-pink.svg',
  'bottle-blue.svg',
  'bottle-pink.svg',
  'butterfly-blue.svg',
  'butterfly-pink.svg',
  'camera-blue.svg',
  'camera-pink.svg',
  'check-blue.svg',
  'check-pink.svg',
  'clock-blue.svg',
  'clock-pink.svg',
  'close-blue.svg',
  'close-pink.svg',
  'comment-blue.svg',
  'comment-filled.svg',
  'crib-blue.svg',
  'crib-pink.svg',
  'drip-feed-blue.svg',
  'drip-feed-pink.svg',
  'duck-blue.svg',
  'duck-pink.svg',
  'eye-blue.svg',
  'eye-pink.svg',
  'flag-blue.svg',
  'flag-pink.svg',
  'graph-blue.svg',
  'graph-pink.svg',
  'heart-blue.svg',
  'heart-filled.svg',
  'heart-pink.svg',
  'home-blue.svg',
  'home-filled.svg',
  'home-pink.svg',
  'kilo-blue.svg',
  'kilo-pink.svg',
  'kiss-blue.svg',
  'kiss-pink.svg',
  'moustache-blue.svg',
  'moustache-pink.svg',
  'pen-blue.svg',
  'pen-pink.svg',
  'phone-blue.svg',
  'phone-pink.svg',
  'plus-blue.svg',
  'plus-pink.svg',
  'question-mark-blue.svg',
  'question-mark-pink.svg',
  'ruler-blue.svg',
  'ruler-pink.svg',
  'search-blue.svg',
  'search-pink.svg',
  'share-blue.svg',
  'share-pink.svg',
  'sleep-blue.svg',
  'sleep-pink.svg',
  'star-filled.svg',
  'tag-pink.svg',
  'trophy-blue.svg',
  'trophy-pink.svg',
  'truck-blue.svg',
  'truck-pink.svg',
  'visit-filled.svg',
  'webcam-filled.svg',
  'right-to-bracket-solid-blue.svg',
  'translate.svg'
];
